import { FullVideoData } from "@/models/FullVideoData"

export default {
  data() {
    return {
      baseurlAdminAppUrl: "https://go.parmonic.com/",
      isLocalhost: window.location.host.indexOf("localhost") > -1,
      localbase: `${window.location.protocol}//${window.location.host.replace(
        "8080",
        "3000"
      )}/`,
      analyticsEventsCaptureEndPoint: "",
      socialShareUrl: "",
      PublishedWebinarDataEndPoint: "https://awapi.blob.core.windows.net/awd/",
      videoPlayers: [],
      isGated: false,
      identifierKey: 0,
      queryEndpoint: "",
      theme_data: {
        font_color: "#000000",
        font_family: "Arial, Helvetica, sans-serif",
        font_size: 11,
        theme_color: "#1aafff"
      },
      time_data: {
        startTime: undefined,
        endTime: undefined,
        screenshotTime: undefined
      },
      eventElement: undefined,
      autoPlay: false,
      fullVideoInfo: new FullVideoData(undefined, undefined),
      logger: undefined
    }
  }
}
